<div class="flex h-full w-full flex-col">
  <dojo-question-validation-header>To evaluate</dojo-question-validation-header>

  @if (showPreviousFeedback().length > 0) {
    <mat-tab-group
      class="custom-mat-tab tabs-body-expanded flex-1"
      style="height: calc(100% - 60px)"
      mat-stretch-tabs="false"
      mat-align-tabs="center"
      animationDuration="250ms"
    >
      <mat-tab class="h-[45px]">
        <ng-template mat-tab-label>
          <span>My Evaluation</span>
        </ng-template>

        <div class="scrollbar-gutter-stable overflow-y-auto pl-2">
          <ng-container *ngTemplateOutlet="feedbackForm"></ng-container>
        </div>
      </mat-tab>

      <mat-tab class="h-[45px]">
        <ng-template mat-tab-label>
          <span>Previous Evaluations ({{ state.previousEvaluations.length }})</span>
        </ng-template>
        <dojo-previous-evaluations
          [evaluations]="state.previousEvaluations"
          [calculatorAllowed]="calculatorAllowed()"
          [markschemeInfo]="markschemeInfo()"
          (formStateChange)="formStateChange.emit($event)"
        >
          <ng-template #badgeTemplate let-evaluation>
            <dojo-reference-question-review-type-badge [reviewType]="evaluation.reviewType" />
          </ng-template>
        </dojo-previous-evaluations>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <div class="scrollbar-gutter-stable overflow-y-auto pl-2">
      <ng-container *ngTemplateOutlet="feedbackForm"></ng-container>
    </div>
  }
</div>

<ng-template #feedbackForm>
  @if (state.showConsensusWarning) {
    <div class="px-2 py-4 text-center text-orange-400 dark:text-orange-300">
      You are seeing this question again because you did not reach consensus with another reviewer. Please review the
      question carefully again.
    </div>
  }

  <dojo-consensus-feedback-form
    [activeReviewMode]="mode()"
    [calculatorAllowed]="calculatorAllowed()"
    [checklistConfig]="dynamicSurveyConfig()"
    [editingAllowed]="editingAllowed()"
    [markschemeInfo]="markschemeInfo()"
    #feedbackFormComponent
    (formStateChange)="formStateChange.emit($event)"
  />
</ng-template>
